
// Metal switcher
function metalSwitcher() {

  // $('.metal-switcher').each( function() {
  //   var thisSwitcher = $(this);
  //   var activeSwitch = $(this).find('.metal-switch.active');
  //   var activeSwitchLeft = activeSwitch.position().left;
  //   thisSwitcher.find('.ring').css('left', activeSwitchLeft).addClass('active');
  // });

  // Switch metal
  $('body').on('click', '.metal-switch', function() { // Work for existing metal-switches and dynamically rendered metal-switches

    // Make active
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    // Product card only
    if ($(this).closest('.product-card').length) {

      var thisProductCard = $(this).closest('.product-card');
      var thisProductCardFirstImage = thisProductCard.find('.upper').find('img').eq(0);
      var thisProductCardTitle = thisProductCard.find('.title');
      var thisProductCardPrice = thisProductCard.find('.price');
      var thisProductCardCompareAtPrice = thisProductCard.find('.compare-at-price');
      var thisProductCardUrl = thisProductCard.children('.inner');
      var thisProductCardBodyImage = thisProductCard.find('.upper').find('img.object-cover');
      var thisProductCardWishlistButton = thisProductCard.find('.wishlist-add');
      var thisProductCardCornerLabel = thisProductCard.find('.corner-label');

      thisProductCard.addClass('no-hover'); // Disable hover effect

      // Change data based on metal selection
      var selectedAltMetalIndex = $(this).attr('data-alt-metal-index'); // index of 0 is default setting
      // First Image
      thisProductCardFirstImage.attr('src', thisProductCardFirstImage.attr('data-alt-metal-'+selectedAltMetalIndex+'-first-image'));
      if (thisProductCardFirstImage.siblings('source')) {
        thisProductCardFirstImage.siblings('source').attr('srcset', thisProductCardFirstImage.siblings('source').attr('data-alt-metal-'+selectedAltMetalIndex+'-first-image-srcset'));
      }
      // Title - replace first hyphen with <span>
      thisProductCardTitle.html(thisProductCardTitle.attr('data-alt-metal-'+selectedAltMetalIndex+'-title').replace('- ', "<span>") + '</span>');
      // Price and compare price
      thisProductCardPrice.text(thisProductCardPrice.attr('data-alt-metal-'+selectedAltMetalIndex+'-price'));
      thisProductCardCompareAtPrice.text(thisProductCardCompareAtPrice.attr('data-alt-metal-'+selectedAltMetalIndex+'-compare-at-price'));
      // Sale style
      if (thisProductCardCompareAtPrice.attr('data-alt-metal-'+selectedAltMetalIndex+'-compare-at-price')) {
        thisProductCard.addClass('sale');
      } else {
        thisProductCard.removeClass('sale');
      }
      // Corner label
      let altMetalCornerLabel = thisProductCardCornerLabel.attr('data-alt-metal-'+selectedAltMetalIndex+'-corner-label');
      if (altMetalCornerLabel) {
        if(altMetalCornerLabel.includes('Sale') || altMetalCornerLabel.includes('Black Friday')) {
          thisProductCardCornerLabel.addClass('sale');
        } else {
          thisProductCardCornerLabel.removeClass('sale');
        }
        if(altMetalCornerLabel == 'Black Friday Early Access') {
          thisProductCardCornerLabel.html('<span class="small">Black Friday</span><span>Early Access</span>');
        } else if(altMetalCornerLabel == 'Black Friday Sale') {
          thisProductCardCornerLabel.html('<span class="small">Black Friday</span><span>Sale</span>');
        } else if(altMetalCornerLabel.includes('Sale') && altMetalCornerLabel.includes('off')) {
          thisProductCardCornerLabel.html('<span>' + altMetalCornerLabel.replace('Sale', '').trim() + '</span>');
        } else {
          thisProductCardCornerLabel.html('<span>' + altMetalCornerLabel + '</span>');
        }
        thisProductCardCornerLabel.show();
      } else {
        thisProductCardCornerLabel.hide();
      }
      // URL
      thisProductCardUrl.attr('href', thisProductCardUrl.attr('data-alt-metal-'+selectedAltMetalIndex+'-link'));
      // Body image
      thisProductCardBodyImage.attr('src', thisProductCardBodyImage.attr('data-alt-metal-'+selectedAltMetalIndex+'-body-image'));
      // if (thisProductCardBodyImage.attr('srcset') !== '') {
      //   thisProductCardBodyImage.attr('srcset', thisProductCardBodyImage.attr('data-alt-metal-'+selectedAltMetalIndex+'-body-image-srcset')); // Change body image srcset
      // }
      // Wishlist button ID
      thisProductCardWishlistButton.attr('data-product-id', thisProductCardWishlistButton.attr('data-alt-metal-'+selectedAltMetalIndex+'-product-id')).removeClass('active');
      if (typeof Appmate !== 'undefined' && Appmate.wk.getProduct(thisProductCardWishlistButton.attr('data-product-id')) !== null) { // If this item is in Wishlist, set active state
        thisProductCardWishlistButton.addClass('active');
      }
      // Product ID
      thisProductCard.attr('data-product-id', thisProductCard.attr('data-alt-metal-'+selectedAltMetalIndex+'-product-id'));
    }
  });

  // Reset hover effect on mouseleave
  $('body').on('mouseleave', '.product-card.no-hover', function() {
    $(this).removeClass('no-hover');
  });

}
metalSwitcher(); // No conditional call as some metal switchers are not present in the DOM on load
